import { render } from "./UpdateEmployee.vue?vue&type=template&id=48416617"
import script from "./UpdateEmployee.vue?vue&type=script&lang=js"
export * from "./UpdateEmployee.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__